import { render } from "./MachineHeader.vue?vue&type=template&id=4b5d93dc&scoped=true"
import script from "./MachineHeader.vue?vue&type=script&lang=js"
export * from "./MachineHeader.vue?vue&type=script&lang=js"

import "./MachineHeader.vue?vue&type=style&index=0&id=4b5d93dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5d93dc"]])

export default __exports__